import React from 'react';
import BsModal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import type { ButtonProps } from 'react-bootstrap/Button';

interface IButton extends ButtonProps {
  label: string;
}

interface IModal {
  title?: string;
  HeaderComponent?: React.ElementType;
  FooterComponent?: React.ElementType;
  BodyComponent?: React.ReactNode;
  onCloseModal: () => void;
  showModal?: boolean;
  buttons?: IButton[];
  showHeader?: boolean;
}

export const Modal = ({
  title,
  HeaderComponent,
  FooterComponent,
  BodyComponent,
  onCloseModal,
  showModal,
  buttons,
  showHeader = true,
  ...restProps
}: IModal) => {
  return (
    <BsModal show={showModal} onHide={onCloseModal} animation={false} {...restProps}>
      {showHeader && (
        <BsModal.Header closeButton>
          {title && (
            <BsModal.Title>
              {' '}
              <h1 className="h1">{title}</h1>{' '}
            </BsModal.Title>
          )}
          {HeaderComponent && <HeaderComponent />}
        </BsModal.Header>
      )}
      {BodyComponent && <BsModal.Body>{BodyComponent}</BsModal.Body>}

      <BsModal.Footer>
        {FooterComponent && <FooterComponent />}
        {buttons?.map((button, idx) => (
          <Button {...button} key={idx}>
            {button.label}
          </Button>
        ))}
      </BsModal.Footer>
    </BsModal>
  );
};
